import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Page404Component } from '../page404/page404.component';
import { SearchDetailsComponent } from './components/search-details/search-details.component';
import { ProjectLocationMapComponent } from './components/maps/project-location-map/project-location-map.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: ProjectLocationMapComponent,
        outlet: 'map',
      },
      {
        path: '',
        component: SearchDetailsComponent,
        outlet: 'searchContent',
      },
    ],
  },
  {
    path: '**',
    component: Page404Component,
    outlet: 'searchContent',
  },
];


@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})
export class SearchRoutingModule {
}
